export const handleError = error => {
    // eslint-disable-next-line no-console
    console.log(error)
}
